import React from "react";
import "./Charts.css";

const SIZE = 180;
const STROKE = 16;
const RADIUS = (SIZE - STROKE) / 2;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

// Leaves a gap at the top of the ring so the arc reads as a gauge.
const SWEEP = 0.82;

const toneFor = (value) => {
  if (value >= 80) return "var(--dgi-good)";
  if (value >= 50) return "var(--dgi-warning)";
  return "var(--dgi-critical)";
};

/**
 * Single-value ring gauge with the score as the hero number, for a 0-100 score.
 */
export default function ScoreGauge({
  value,
  max = 100,
  label = "of 100",
  display,
  size,
}) {
  const fraction = Math.min(Math.max(value / max, 0), 1);
  const track = CIRCUMFERENCE * SWEEP;
  const filled = track * fraction;
  const rotation = -90 + ((1 - SWEEP) / 2) * 360;

  return (
    <svg
      viewBox={`0 0 ${SIZE} ${SIZE}`}
      className={`gauge${size ? ` gauge--${size}` : ""}`}
      role="img"
      aria-label={`Score ${value} ${label}`}
    >
      <g transform={`rotate(${rotation} ${SIZE / 2} ${SIZE / 2})`}>
        <circle
          cx={SIZE / 2}
          cy={SIZE / 2}
          r={RADIUS}
          fill="none"
          stroke="#e8edf5"
          strokeWidth={STROKE}
          strokeLinecap="round"
          strokeDasharray={`${track} ${CIRCUMFERENCE - track}`}
        />
        <circle
          cx={SIZE / 2}
          cy={SIZE / 2}
          r={RADIUS}
          fill="none"
          stroke={toneFor(value)}
          strokeWidth={STROKE}
          strokeLinecap="round"
          strokeDasharray={`${filled} ${CIRCUMFERENCE - filled}`}
        />
      </g>

      <text
        x="50%"
        y="48%"
        textAnchor="middle"
        dominantBaseline="middle"
        className="gauge__value"
      >
        {display ?? value}
      </text>
      <text
        x="50%"
        y="62%"
        textAnchor="middle"
        dominantBaseline="middle"
        className="gauge__label"
      >
        {label}
      </text>
    </svg>
  );
}
